
export const GET_STORES_REQUEST = 'GET_STORES_REQUEST';
export const GET_STORES_SUCCESS = 'GET_STORES_SUCCESS';
export const GET_STORES_FAILURE = 'GET_STORES_FAILURE';

export const SET_STORE = 'SET_STORE';

export const SET_STORES = 'SET_STORES';

export const SUBMIT_STORE_REQUEST = 'SUBMIT_STORE_REQUEST';
export const SUBMIT_STORE_SUCCESS = 'SUBMIT_STORE_SUCCESS';
export const SUBMIT_STORE_FAILURE = 'SUBMIT_STORE_FAILURE';

export const CREATE_SINGLE_STORE_REQUEST = 'CREATE_SINGLE_STORE_REQUEST';
export const CREATE_SINGLE_STORE_SUCCESS = 'CREATE_SINGLE_STORE_SUCCESS';
export const CREATE_SINGLE_STORE_FAILURE = 'CREATE_SINGLE_STORE_FAILURE';

export const CREATE_STORES_BATCH_REQUEST = 'CREATE_STORES_BATCH_REQUEST';
export const CREATE_STORES_BATCH_SUCCESS = 'CREATE_STORES_BATCH_SUCCESS';
export const CREATE_STORES_BATCH_FAILURE = 'CREATE_STORES_BATCH_FAILURE';

export const getStoresRequest = (filters = {}) => {
    const modifiedFilters = { ...filters };
    

    if (modifiedFilters.type !== undefined && !Array.isArray(modifiedFilters.type)) {
        modifiedFilters.type = [modifiedFilters.type];
    }
    
    
    return {
        type: GET_STORES_REQUEST,
        payload: {
            filters: modifiedFilters
        }
    };
};

export const getStoresSuccess = (stores, total) => ({
    type: GET_STORES_SUCCESS,
    payload: {
        stores,
        total
    }
});

export const getStoresFailure = error => ({
    type: GET_STORES_FAILURE,
    error: error
});

export const setStore = (store = {}) => ({
    type: SET_STORE,
    payload: {
        store
    }
});

export const setStores = (stores = []) => ({
    type: SET_STORES,
    payload: {
        stores
    }
});

export const submitStoreRequest = (store, history) => ({
    type: SUBMIT_STORE_REQUEST,
    payload: {
        store
    },
    history
});

export const submitStoreSuccess = stores => ({
    type: SUBMIT_STORE_SUCCESS,
    payload: {
        stores
    }
});

export const submitStoreFailure = error => ({
    type: SUBMIT_STORE_FAILURE,
    error: error
});

export const createStoresBatchRequest = (stores) => ({
    type: CREATE_STORES_BATCH_REQUEST,
    payload: {
        stores
    }
});

export const createStoresBatchSuccess = () => ({
    type: CREATE_STORES_BATCH_SUCCESS
});

export const createStoresBatchFailure = error => ({
    type: CREATE_STORES_BATCH_FAILURE,
    error: error
});

export const createSingleStoreRequest = (store, history) => ({
    type: CREATE_SINGLE_STORE_REQUEST,
    payload: {
        store
    },
    history
});

export const createSingleStoreSuccess = stores => ({
    type: CREATE_SINGLE_STORE_SUCCESS,
    payload: {
        stores
    }
});

export const createSingleStoreFailure = error => ({
    type: CREATE_SINGLE_STORE_FAILURE,
    error: error
});
